"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPreviewLink = exports.getPostPreview = exports.getSitePreview = void 0;

var _toolkit = require("@reduxjs/toolkit");

var _rest = _interopRequireDefault(require("../api/rest"));

var getSitePreview = (0, _toolkit.createAsyncThunk)('preview/getSite', /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args, thunkAPI) {
    var _thunkAPI$getState, source, response;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _thunkAPI$getState = thunkAPI.getState(), source = _thunkAPI$getState.cms.config.source;
            _context.next = 3;
            return (0, _rest.default)('getSitePreview', args, source);

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
exports.getSitePreview = getSitePreview;
var getPostPreview = (0, _toolkit.createAsyncThunk)('preview/getPost', /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args, thunkAPI) {
    var _thunkAPI$getState2, source, response;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _thunkAPI$getState2 = thunkAPI.getState(), source = _thunkAPI$getState2.cms.config.source;
            _context2.next = 3;
            return (0, _rest.default)('getPostPreview', args, source);

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}());
exports.getPostPreview = getPostPreview;
var getPreviewLink = (0, _toolkit.createAsyncThunk)('preview/getLink', /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(args, thunkAPI) {
    var _thunkAPI$getState3, source, response;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _thunkAPI$getState3 = thunkAPI.getState(), source = _thunkAPI$getState3.cms.config.source;
            _context3.next = 3;
            return (0, _rest.default)('getPreviewLink', args, source);

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}());
exports.getPreviewLink = getPreviewLink;